import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Registro from "@/pages/Registro";
import Home from "@/pages/Home";
import WorkspaceLayout from "@/layouts/WorkspaceLayout";
import Dashboard from "@/pages/Dashboard";
import MapaMaestro from "@/pages/MapaMaestro";
import Tramites from "@/pages/Tramites";
import TramiteDetail from "@/pages/TramiteDetail";
import Catalogo from "@/pages/Catalogo";
import Alertas from "@/pages/Alertas";
import Auditoria from "@/pages/Auditoria";
import Usuarios from "@/pages/Usuarios";
import Gestion from "@/pages/Gestion";
import Desarrollo from "@/pages/Desarrollo";
import FichaProducto from "@/pages/FichaProducto";
import Creditos from "@/pages/Creditos";
import CreditoDetail from "@/pages/CreditoDetail";
import Construccion from "@/pages/Construccion";
import Comercializacion from "@/pages/Comercializacion";
import CeoDashboard from "@/pages/CeoDashboard";
import AyudaIA from "@/components/AyudaIA";
import NamtechFooter from "@/components/NamtechFooter";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="h-screen flex items-center justify-center bg-[#001D33]">
        <div className="text-white/60 font-display text-lg tracking-widest animate-pulse">DEVELOPWARE</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/" element={<Protected><Home /></Protected>} />
          <Route path="/ceo" element={<Protected><CeoDashboard /></Protected>} />
          <Route path="/p/:pid" element={<Protected><WorkspaceLayout /></Protected>}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="mapa" element={<MapaMaestro />} />
            <Route path="tramites" element={<Tramites />} />
            <Route path="tramites/:tid" element={<TramiteDetail />} />
            <Route path="catalogo" element={<Catalogo />} />
            <Route path="alertas" element={<Alertas />} />
            <Route path="auditoria" element={<Auditoria />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="gestion" element={<Gestion />} />
            <Route path="desarrollo" element={<Desarrollo />} />
            <Route path="desarrollo/:upeId" element={<FichaProducto />} />
            <Route path="creditos" element={<Creditos />} />
            <Route path="creditos/:cid" element={<CreditoDetail />} />
            <Route path="construccion" element={<Construccion />} />
            <Route path="comercializacion" element={<Comercializacion />} />
          </Route>
        </Routes>
        <AyudaIA />
        <NamtechFooter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
